import { formatDateTime } from "../../utils/format";
import EmptyState from "../common/EmptyState";

const TONE = {
  Submitted: "info",
  Approved: "success",
  "Changes requested": "warning",
  "Reopened by HR": "warning",
  Finalized: "success",
};

export default function ActivityTimeline({ items = [], emptyText = "No activity recorded yet." }) {
  if (!items.length) return <EmptyState title="No history" text={emptyText} compact />;
  return (
    <ol className="timeline">
      {items.map((item) => (
        <li key={item.id} className={`timeline-item tone-${TONE[item.action] || "neutral"}`}>
          <span className="timeline-dot" aria-hidden="true" />
          <div>
            <p className="timeline-title">
              <strong>{item.action}</strong> by {item.actorName || "System"}
            </p>
            {item.comment && <p className="timeline-comment">{item.comment}</p>}
            <p className="timeline-time">{formatDateTime(item.at)}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
